import { useEffect, useState } from 'react'

function useParamId(index?: number) {
  const [paramId, setParamId] = useState<number | undefined>()

  const handleParamId = () => {
    const popId = typeof index === 'number' ? location.pathname.split('/')[index] : location.pathname.split('/').pop()
    if (popId && !isNaN(Number(popId))) setParamId(Number(popId))
  }

  useEffect(() => {
    handleParamId()
    return () => {
      setParamId(undefined)
    }
  }, [location])

  return paramId
}

export default useParamId
